export const primaryColor = '#04D0F2';
export const primaryColorDark = '#0399B2';
export const primaryColorLight = '#04DBFF';

export const accentColor = '#DA0443';
export const accentColorDark = '#C0043B';
export const accentColorLight = '#E70447';

export const accentColorDarkGradient = `linear-gradient(
  to bottom right,
  ${accentColor},
  ${accentColorDark}
)`;
export const accentColorLightGradient = `linear-gradient(
  to bottom right,
  ${accentColorLight},
  ${accentColor}
)`;

export const primaryText = '#FEFEFE';
export const secondaryText = '#212121';
export const accentText = '#590935';

export const backgroundContrast = '#242A43';
export const backgroundContrastDark = '#1B2033';
export const backgroundContrastLight = '#4D5A8F';
export const backgroundContrastDarkGradient = `linear-gradient(
  to bottom right,
  ${backgroundContrast},
  ${backgroundContrastDark}
)`;
export const backgroundContrastLightGradient = `linear-gradient(
  to bottom right,
  ${backgroundContrastLight},
  ${backgroundContrast}
)`;

export const backgroundColor = '#040424';
export const backgroundColorDark = '#01011C';
export const backgroundColorLight = '#060633';
export const backgroundDarkGradient = `linear-gradient(
  to bottom right,
  ${backgroundColor},
  ${backgroundColorDark}
)`;
export const backgroundLightGradient = `linear-gradient(
  to bottom right,
  ${backgroundColorLight},
  ${backgroundColor}
)`;

export const errorColor = '#C2043C';
